// Our production Regula license is bound to the authenticating.com domain, so any
// non-production build served from that domain charges ID checks to production.
// These environments must run on authenticate.com instead.
//
// Explicit list on purpose: a missing or mistyped REACT_APP_ENV must never block production.
export const RESTRICTED_ENVS = new Set(['stage', 'alpha', 'sandbox_dev', 'sandbox']);

const RESTRICTED_DOMAIN = 'authenticating.com';
const ALLOWED_DOMAIN = 'authenticate.com';

const normalize = (hostname) => (typeof hostname === 'string' ? hostname.toLowerCase() : '');

// Whole-domain match: `authenticating.com` or any subdomain of it, never a look-alike
// such as `notauthenticating.com` or `authenticating.com.example.org`.
export const isRestrictedHost = (hostname) => {
    const host = normalize(hostname);
    return host === RESTRICTED_DOMAIN || host.endsWith(`.${RESTRICTED_DOMAIN}`);
};

export const getAllowedHost = (hostname) =>
    normalize(hostname).replace(/authenticating\.com$/, ALLOWED_DOMAIN);

export const isRestrictedDomain = ({
    env = process.env.REACT_APP_ENV,
    hostname = globalThis.location?.hostname,
} = {}) => RESTRICTED_ENVS.has(env) && isRestrictedHost(hostname);
